// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calculation"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.70508 20.6676L6.53351 17.8392M6.53351 17.8392L9.36193 15.0107M6.53351 17.8392L3.86561 15.1713M6.53351 17.8392L9.52246 20.8281M3 6.5H6.5M6.5 6.5H10M6.5 6.5V3M6.5 6.5V10M14 6.5L21 6.5M14 18H21M17.5 14.998H17.5039V15.002H17.5V14.998ZM17.5 20.998H17.5039V21.002H17.5V20.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CalculationIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calculation',
    ref,
    icon: element,
  },
));

CalculationIcon.displayName = 'CalculationIcon';

export default CalculationIcon;
